// extracted by mini-css-extract-plugin
module.exports = {"HeroFilteredPage":"styles_HeroFilteredPage__8ntzW","title":"styles_title__YkjBd","image":"styles_image__e3j8f","content":"styles_content___ifDt"};